var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93997 0.187561C7.52589 0.187561 7.19018 0.523259 7.19018 0.937355C7.19018 1.35145 7.52589 1.68715 7.93997 1.68715H15.607L0.411373 16.8828C0.112876 17.1812 0.112876 17.6652 0.411373 17.9637C0.709861 18.2622 1.19382 18.2622 1.49231 17.9637L16.6876 2.76843V10.4347C16.6876 10.8488 17.0233 11.1845 17.4374 11.1845C17.8514 11.1845 18.1872 10.8488 18.1872 10.4347V0.937355C18.1872 0.523259 17.8514 0.187561 17.4374 0.187561H7.93997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7c90d001953e9dc168b1a568ca260229.svg";
export { ForwardRef as ReactComponent };